<template>
  <tbody>
  <tr :class="['clickable', {disabled: !entity.active, updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Popis' | translate">
      {{ entity.description }}
    </td>
    <td :data-th="'Počet balíčků' | translate">
      {{ entity.package_count }}
    </td>
    <td :data-th="'Počet videí' | translate">
      {{ entity.videos_count }}
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";

export default {
  name: "VodProvidersRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data(){
    return{
      detailPageRouteName: "vodProvidersDetail",
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodProviders/VodProvidersRow.vue